import type { ReactNode } from 'react'
import {
  AccountBookOutlined,
  ApartmentOutlined,
  WifiOutlined,
  ApiOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BellOutlined,
  BookOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  ClusterOutlined,
  CreditCardOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  FieldTimeOutlined,
  FileDoneOutlined,
  FileTextOutlined,
  FundOutlined,
  FileProtectOutlined,
  GiftOutlined,
  GlobalOutlined,
  HistoryOutlined,
  IdcardOutlined,
  InboxOutlined,
  MailOutlined,
  NotificationOutlined,
  OrderedListOutlined,
  PartitionOutlined,
  PhoneOutlined,
  PictureOutlined,
  PieChartOutlined,
  ProfileOutlined,
  RiseOutlined,
  SafetyCertificateOutlined,
  ScanOutlined,
  ScheduleOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  SolutionOutlined,
  StarOutlined,
  SyncOutlined,
  TagsOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  UnorderedListOutlined,
  UserOutlined,
  SwapOutlined,
  WalletOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'
import type { Permission } from '@/shared/auth/permissions'

export interface NavItem {
  /** Menyu kaliti — marshrut yo'li bilan bir xil, ikkinchi manba bo'lmasin */
  path: string
  labelKey: string
  icon: ReactNode
  /**
   * Kamida bittasi bo'lsa havola ko'rinadi.
   *
   * ⚠️ Bu QULAYLIK, xavfsizlik EMAS (04-ROLES.md §8). Yashirilgan sahifa
   * URL orqali ochilishi mumkin — u yerda `RequirePermission` "ruxsat yo'q"
   * ko'rsatadi, ma'lumot esa baribir backend tekshiruvidan o'tadi.
   */
  permission?: readonly Permission[]

  /**
   * HAMMASI bo'lsa havola ko'rinadi — {@code permission} dan farqli
   * o'laroq YOKI emas, VA.
   *
   * ⚠️ Nega kerak bo'ldi (B11): «Kampaniyalar» sahifasi ikki huquqqa
   * tayanadi — `campaign.manage` (endpoint) va `venue.read` (server
   * qatorlarni `VenueScopeGuard` orqali filtrlaydi). Ikkinchisisiz
   * sahifa ochilardi, so'rov 200 berardi, ro'yxat esa CHALA bo'lardi.
   *
   * ⚠️ `permission` ning semantikasi ATAYLAB o'zgartirilmadi: uni VA
   * ga aylantirish 30 dan ortiq banddan ba'zilarini jimgina
   * yashirardi. Yangi maydon — o'zgarish AYNAN kerakli joyda qoladi.
   *
   * Ikkalasi birga berilsa ikkalasi ham bajarilishi shart.
   */
  allPermissions?: readonly Permission[]

  /**
   * Faqat PLATFORMA EGASIGA (GLOBAL ko'rinish doirasi) ko'rinsin.
   *
   * <p>Nega huquqning o'zi yetmaydi: rollar bu tizimda dinamik
   * (`04-ROLES.md` §1), ya'ni tashkilot admini `role.create` bilan
   * o'ziga `tenant.read` li rol yasab olishi mumkin edi. Doira esa
   * boshqa o'lchov va uni o'ziga berish uchun allaqachon GLOBAL
   * bo'lish kerak (self-escalation bloki).
   *
   * <p>⚠️ Bu ham QULAYLIK, xavfsizlik emas — backend ikkala shartni
   * ham qayta tekshiradi (`TenantAdminServiceImpl#requirePlatformOwner`).
   */
  globalScopeOnly?: boolean
}

export interface NavGroup {
  key: string
  labelKey: string
  icon: ReactNode
  items: readonly NavItem[]
}

/**
 * Menyu yozuvi — GURUH yoki YUQORI DARAJADAGI BAND.
 *
 * ⚠️ Yuqori darajadagi band nima uchun kerak: ichida bittagina havola
 * bo'lgan guruh akkordeonni ochib, bitta havola ko'rsatardi — ya'ni bir
 * bosish ortiqcha edi va u HAR SAFAR to'lanardi. «Boshqaruv paneli» va
 * «Hisobotlar» aynan shunday edi.
 */
export type NavEntry = NavGroup | NavItem

/** Yozuv guruhmi yoki yolg'iz bandmi — `items` borligi ajratadi. */
// eslint-disable-next-line react-refresh/only-export-components
export function isNavGroup(entry: NavEntry): entry is NavGroup {
  return 'items' in entry
}

// Bu fayl komponent EKSPORT QILMAYDI — faqat ma'lumot va yordamchi
// funksiyalar (ikonkalar JSX bo'lgani uchun kengaytmasi .tsx).
// `react-refresh` qoidasi buni ajrata olmaydi, shuning uchun o'chirilgan.
//
// GURUHLAR YOPILADIGAN (akkordeon) — `AppSider` ga qarang. Shuning uchun
// guruhning O'ZIDA ham ikonka bor: yig'ilgan sidebar'da faqat u ko'rinadi.
//
// ⚠️ RO'YXATDA IKKI XIL YOZUV BOR: guruh va YOLG'IZ BAND (`NavEntry`).
// Yolg'iz band `items` siz yoziladi va akkordeonsiz, bir bosishda
// ochiladi.
//
// ⚠️ ⚠️ 2026-08-13 — MENYU QISQARTIRILDI (egasi qarori): 15 guruh → 11
// guruh + 2 yolg'iz band. Bandlar soni O'ZGARMADI (47 ta) va hech
// kimning huquqi tegilmadi — guruh faqat YORLIQ, `useSidebarMenu` har
// bandni alohida filtrlaydi. Nima birlashdi:
//   · «Davomat» + «Kadrlar» → «Kadrlar»            (quyida, sababi bilan)
//   · «Agentlar» + «Tashkiliy tuzilma» → ikkinchisi (quyida)
//   · «Asosiy» va «Hisobotlar» guruhlari → yolg'iz band
// Har uchala o'rinda ESKI, TESKARI izoh turgan edi. Ular BEKOR
// QILINGAN deb ochiq belgilangan — o'chirilmagan, chunki dalilning
// o'zi hamon to'g'ri, faqat undan chiqarilgan xulosa o'zgardi.
//
// ⚠️ RO'YXATDA FAQAT HAQIQIY MANZILLAR BOR. Taklif qilingan tuzilmadagi
// ba'zi bo'limlar (Grantlar, Narx ro'yxati, Depozit, Komissiya va
// hisobotning to'rt bo'lagi) bu yerda YO'Q va bu ataylab:
//   · Grantlar / Depozit / Komissiya — alohida sahifa emas, ular abonent va
//     agent kartochkasi ICHIDAGI panellar
//   · Narx ro'yxati / hisobot bo'laklari — backendda mos endpoint yo'q
// Ularga havola chizish "bosdim, hech narsa ochilmadi" degan o'lik havola
// bo'lardi — bo'sh guruhdan ham yomonroq.
//
// ⚠️ "PSP sozlamalari" bu ro'yxatdan CHIQARILDI: endi u HAQIQIY manzil
// (`/payment-providers` → `xsib-payments` `PspProviderResource`). Ilgari
// u "backendda mos endpoint yo'q" toifasida edi va aynan shu sababli
// `psp.read`/`psp.configure` huquqlari hech narsani boshqarmasdi.
// eslint-disable-next-line react-refresh/only-export-components
export const NAV: readonly NavEntry[] = [
  // Boshqaruv paneli — YOLG'IZ BAND, guruh EMAS (`NavEntry` izohi).
  {
    path: '/',
    labelKey: 'nav.dashboard',
    icon: <DashboardOutlined />,
  },
  {
    key: 'subscribers',
    labelKey: 'nav.group.subscribers',
    icon: <TeamOutlined />,
    items: [
      {
        path: '/subscribers',
        labelKey: 'nav.subscriberList',
        icon: <TeamOutlined />,
        permission: ['subscriber.read'],
      },
      {
        path: '/subscribers/contracts',
        labelKey: 'nav.contracts',
        icon: <FileProtectOutlined />,
        permission: ['subscriber.contract.view'],
      },
      {
        /* Berilgan paketlar — `GET /api/grants`. Abonentlar guruhida,
           chunki qator ABONENTGA berilgan paketni bildiradi; `/plans`
           esa katalogdagi sotuv yozuvi (01-DOMAIN-MODEL.md §1). */
        path: '/grants',
        labelKey: 'nav.grants',
        icon: <GiftOutlined />,
        permission: ['subscriber.read'],
      },
      {
        path: '/vouchers',
        labelKey: 'nav.vouchers',
        icon: <GiftOutlined />,
        // ⚠️ `plan.read` EMAS — `VoucherController` maxsus `voucher.*` kodga
        // ega emas, `subscriber.read`/`subscriber.create` qarzga olingan
        // (`voucherApi.ts` izohi). Ro'yxatni ko'rish uchun minimali shu.
        permission: ['subscriber.read'],
      },
      {
        path: '/vouchers/register',
        labelKey: 'nav.voucherRegister',
        icon: <UnorderedListOutlined />,
        permission: ['subscriber.read'],
      },
      {
        path: '/vouchers/transfers',
        labelKey: 'nav.voucherTransfers',
        icon: <SwapOutlined />,
        permission: ['subscriber.read'],
      },
      {
        path: '/vouchers/activations',
        labelKey: 'nav.voucherActivations',
        icon: <HistoryOutlined />,
        permission: ['subscriber.read'],
      },
      {
        path: '/vouchers/visp-report',
        labelKey: 'nav.voucherVispReport',
        icon: <PieChartOutlined />,
        permission: ['subscriber.read'],
      },
      {
        path: '/subscribers/device-types',
        labelKey: 'nav.deviceTypes',
        icon: <WifiOutlined />,
        permission: ['subscriber.read'],
      },
    ],
  },
  {
    key: 'sales',
    labelKey: 'nav.group.sales',
    icon: <ShoppingOutlined />,
    items: [
      // Plan ≠ Policy (01-DOMAIN-MODEL.md §1): birinchisi sotuv (narx),
      // ikkinchisi texnik cheklov. Bitta Policy bir necha Plan'da ishlatiladi,
      // shuning uchun ular alohida sahifalarda qoladi
      {
        path: '/plans',
        labelKey: 'nav.plans',
        icon: <ShoppingOutlined />,
        permission: ['plan.read'],
      },
      {
        path: '/policies',
        labelKey: 'nav.policies',
        icon: <SafetyCertificateOutlined />,
        permission: ['plan.read'],
      },
    ],
  },
  {
    key: 'venue',
    labelKey: 'nav.group.venue',
    icon: <ShopOutlined />,
    items: [
      // Venue TENANT emas: mehmonxona/kafe tarmog'ining har filiali alohida
      // ob'ekt (01-DOMAIN-MODEL.md, `venue/api/Venue.java` javadoc)
      {
        path: '/venues',
        labelKey: 'nav.venues',
        icon: <ShopOutlined />,
        permission: ['venue.read'],
      },
      {
        path: '/venues/journal',
        labelKey: 'nav.venueJournal',
        icon: <BookOutlined />,
        permission: ['venue.read'],
      },
      {
        path: '/venues/campaigns',
        labelKey: 'nav.venueCampaigns',
        icon: <NotificationOutlined />,
        /*
          ⚠️ `allPermissions` — YOKI emas, VA (B11).

          Ilgari bu yerda `permission: ['campaign.manage']` turardi.
          Server esa ro'yxatni `VenueScopeGuard` → `VENUE_READ` dan
          o'tkazadi, ya'ni `venue.read` siz sahifa CHALA ro'yxat
          ko'rsatardi (o'lchandi: uchtadan bittasi, HTTP 200, xato yo'q).

          ⚠️ `permission: ['campaign.manage', 'venue.read']` YOZIB
          BO'LMAYDI: u ro'yxat ichida YOKI degani va nuqsonni
          YOMONLASHTIRARDI — `venue.read` yolg'iz bo'lgan xodimga ham
          havola ko'rinardi.
        */
        allPermissions: ['campaign.manage', 'venue.read'],
      },
    ],
  },
  /*
    Tashkiliy tuzilma — QARORLAR.md §19.

    ⚠️ 2026-08-13: «Agentlar» GURUHI SHU YERGA BIRLASHTIRILDI (egasi
    qarori). Ilgari ular ikki ayrim guruh edi va bu yerda "agentlardan
    keyin turgani ma'noli" deb yozilgan edi. Sabab o'zgarmadi, xulosa
    o'zgardi: agent va reseller — AYNAN SHU daraxtning tugunlari
    (`platform.org_node`), faqat boshqa turdagi. Akkordeon bir vaqtda
    bitta guruhni ochadi, ya'ni "yonma-yon" turish amalda "guruh
    almashtirish" degani edi — «agentim qaysi filial ostida» degan
    savol ikki bosish talab qilardi. Endi bir guruh ichida.

    ⚠️ KEYINGI AGENTGA: bu birlashtirishni ORQAGA QAYTARMANG. U
    tasodifiy emas — menyu 15 guruhdan 11 taga tushirilgan ishning bir
    qismi va egasi tomonidan alohida tasdiqlangan.

    TARTIB kundalik ish CHASTOTASI bo'yicha (`stock` guruhidagi bilan
    bir xil qoida): agent bilan har kuni ishlanadi (depozit, komissiya),
    daraxt esa kamdan-kam o'zgaradi.

    ⚠️ Agent ≠ Reseller (01-DOMAIN-MODEL.md §5): birinchisi naqd qabul
    qiladi va komissiya oladi, ikkinchisi o'z narxi bilan qayta sotadi.

    «Birlik turlari» — faqat SUPERADMIN (`org.type.write`, egasi qarori
    2026-09-29): tizim turlarini tahrirlash jonli muhitda yaratishni buzgan.

    ⚠️ HUQUQLAR BIRLASHMADI: agent bandlari `agent.read`, daraxt
    bandlari `org.node.read` ostida QOLDI. Guruh — faqat yorliq, u
    hech kimga yangi narsa ochmaydi (`useSidebarMenu` har bandni
    alohida filtrlaydi). RESELLER/AGENT rollarida `org.node.read`
    yo'q, ya'ni ular bu guruhda faqat agent bandlarini ko'radi.
  */
  {
    key: 'org',
    labelKey: 'nav.group.org',
    icon: <PartitionOutlined />,
    items: [
      {
        path: '/agents',
        labelKey: 'nav.agents',
        icon: <IdcardOutlined />,
        permission: ['agent.read'],
      },
      {
        path: '/resellers',
        labelKey: 'nav.resellers',
        icon: <ApartmentOutlined />,
        permission: ['agent.read'],
      },
      {
        path: '/org/structure',
        labelKey: 'nav.orgStructure',
        icon: <PartitionOutlined />,
        permission: ['org.node.read'],
      },
      {
        path: '/org/node-types',
        labelKey: 'nav.orgNodeTypes',
        icon: <TagsOutlined />,
        permission: ['org.type.write'],
      },
    ],
  },
  {
    key: 'cash',
    labelKey: 'nav.group.cash',
    icon: <DollarOutlined />,
    items: [
      {
        path: '/cashdesk',
        labelKey: 'nav.cashdesk',
        icon: <ShopOutlined />,
        permission: ['cash.receipt.create'],
      },
      {
        path: '/cash/branches',
        labelKey: 'nav.branchCash',
        icon: <BankOutlined />,
        permission: ['cash.balance.view'],
      },
      {
        path: '/cash/transfers',
        labelKey: 'nav.cashTransfers',
        icon: <SwapOutlined />,
        permission: ['cash.balance.view'],
      },
      {
        path: '/cash/collect-limits',
        labelKey: 'nav.collectLimits',
        icon: <SafetyCertificateOutlined />,
        permission: ['cash.collect.limit.manage'],
      },
      {
        path: '/cash/discounts',
        labelKey: 'nav.discountApprovals',
        icon: <TagsOutlined />,
        permission: ['cash.discount.approve', 'cash.discount.apply'],
      },
      {
        path: '/invoices',
        labelKey: 'nav.invoices',
        icon: <FileTextOutlined />,
        permission: ['invoice.view'],
      },
    ],
  },
  {
    key: 'finance',
    labelKey: 'nav.group.finance',
    icon: <WalletOutlined />,
    items: [
      /*
        Buxgalteriya (`xsib-finance`) — QARORLAR.md §18.

        ⚠️ `ledger` BILAN BIR BO'LIMDA, lekin BOSHQA huquqlar ostida.
        Ular bir ekranga tegishli mavzu (pul), ammo `ledger` — jonli
        operatsion jurnal, bu esa yopilgan davrlar va xarajatlar.
        Huquqlarni birlashtirish "abonent balansini ko'radigan har kim
        tashkilotning foydasini ham ko'radi" degani bo'lardi.

        ⚠️ Uchalasi ham `finance.*.view` bilan — `.read` bilan EMAS
        (`shared/auth/permissions.ts` dagi izoh: `%.read` "Kuzatuvchi"
        roliga o'z-o'zidan qo'shiladi).
      */
      {
        path: '/finance/branch-cash',
        labelKey: 'nav.financeBranchCash',
        icon: <AccountBookOutlined />,
        permission: ['cash.balance.view'],
      },
      {
        path: '/finance/dashboard',
        labelKey: 'nav.financeDashboard',
        icon: <FundOutlined />,
        permission: ['finance.dashboard.view'],
      },
      {
        // Filial jamlovchi hisoboti (P&L) — filiallarni taqqoslash,
        // kompaniya KPI, bosh ofis jamlovchi ko'rinishi (docs/11 §3, §5.5).
        // `/api/finance/reports/branches` ham `finance.account.view` ostida.
        path: '/finance/branches',
        labelKey: 'nav.financeBranches',
        icon: <BankOutlined />,
        permission: ['finance.account.view'],
      },
      {
        /*
          Tranzaksiyalar — BARCHA yozuvlar bitta filtrlanadigan jadvalda
          (`GET /api/ledger/entries`). Egasi talabi: "barcha tranzaksiyalar
          shu yerda bo'lishi kk".

          ⚠️ `/ledger` dan ALOHIDA band va u AYNI huquq ostida: server
          ikkalasini ham `ledger.read` bilan qo'riqlaydi. Bu ro'yxat
          hisoblar ro'yxatini almashtirmaydi — ular ikki xil savolga
          javob beradi ("kimda qancha bor" va "pul qanday harakatlandi").
        */
        path: '/transactions',
        labelKey: 'nav.transactions',
        icon: <SwapOutlined />,
        permission: ['ledger.read'],
      },
      {
        path: '/payments',
        labelKey: 'nav.payments',
        icon: <CreditCardOutlined />,
        permission: ['payment.read'],
      },
      {
        path: '/suppliers',
        labelKey: 'nav.suppliers',
        icon: <ShopOutlined />,
        permission: ['supplier.view'],
      },
      {
        path: '/purchases',
        labelKey: 'nav.purchases',
        icon: <ShoppingOutlined />,
        permission: ['supplier.view'],
      },
    ],
  },
  {
    key: 'accounting',
    labelKey: 'nav.group.accounting',
    icon: <BookOutlined />,
    items: [
      {
        // ⚠️ IKKI huquqdan biri yetarli: jurnalni o'qish va xarajat
        // kiritish boshqa-boshqa odamlar bo'lishi mumkin.
        path: '/finance/journal',
        labelKey: 'nav.financeJournal',
        icon: <FileTextOutlined />,
        permission: ['finance.period.view', 'finance.expense.write'],
      },
      {
        path: '/finance/periods',
        labelKey: 'nav.financePeriods',
        icon: <CalendarOutlined />,
        permission: ['finance.period.view'],
      },
      {
        path: '/finance/accounts',
        labelKey: 'nav.financeAccounts',
        icon: <BookOutlined />,
        permission: ['finance.account.view'],
      },
      {
        // Foyda hisoboti (P&L) — hujjatning oltita «foyda» bandi
        // (docs/11 §5.3). `/api/finance/reports/income-statement` ham
        // `finance.account.view` ostida.
        path: '/finance/income-statement',
        labelKey: 'nav.financeIncomeStatement',
        icon: <FundOutlined />,
        permission: ['finance.account.view'],
      },
      {
        // Aylanma-qoldiq vedomosti — ERP ga uzatiladigan asosiy shakl.
        // `/api/finance/reports/trial-balance` ham `finance.account.view`.
        path: '/finance/trial-balance',
        labelKey: 'nav.financeTrialBalance',
        icon: <FileDoneOutlined />,
        permission: ['finance.account.view'],
      },
      {
        path: '/finance/balance-sheet',
        labelKey: 'nav.financeBalanceSheet',
        icon: <ScheduleOutlined />,
        permission: ['finance.account.view'],
      },
      {
        path: '/finance/cash-flow',
        labelKey: 'nav.financeCashFlow',
        icon: <SwapOutlined />,
        permission: ['finance.account.view'],
      },
      {
        path: '/ledger',
        labelKey: 'nav.ledger',
        icon: <WalletOutlined />,
        permission: ['ledger.read'],
      },
      {
        path: '/finance/stakeholders',
        labelKey: 'nav.stakeholders',
        icon: <TeamOutlined />,
        permission: ['stakeholder.view'],
      },
      {
        path: '/finance/stakeholder-distributions',
        labelKey: 'nav.stakeholderDistributions',
        icon: <PieChartOutlined />,
        permission: ['stakeholder.view'],
      },
    ],
  },
  {
    key: 'network',
    labelKey: 'nav.group.network',
    icon: <ThunderboltOutlined />,
    items: [
      {
        path: '/sessions',
        labelKey: 'nav.sessions',
        icon: <ThunderboltOutlined />,
        permission: ['subscriber.read'],
      },
      { path: '/nas', labelKey: 'nav.nas', icon: <ClusterOutlined />, permission: ['nas.read'] },
      {
        path: '/network/visps',
        labelKey: 'nav.networkVisps',
        icon: <ApiOutlined />,
        permission: ['network.visp.read'],
      },
      // Joylashuv va inventar `Tarmoq` guruhida: ikkalasi ham "qurilma
      // qayerda va u ishlayaptimi" degan bitta savolga xizmat qiladi, NAS
      // ro'yxati bilan yonma-yon turgani shuning uchun to'g'ri
      {
        path: '/sites',
        labelKey: 'nav.sites',
        icon: <EnvironmentOutlined />,
        permission: ['site.read'],
      },
      // Viloyat/tuman — joylashuv va manzil shakllari tanlaydigan
      // ma'lumotnoma, shuning uchun `/sites` bilan yonma-yon
      {
        path: '/geo/regions',
        labelKey: 'nav.geoRegions',
        icon: <GlobalOutlined />,
        permission: ['geo.read'],
      },
      {
        path: '/geo/districts',
        labelKey: 'nav.geoDistricts',
        icon: <PartitionOutlined />,
        permission: ['geo.read'],
      },
      {
        path: '/inventory',
        labelKey: 'nav.inventory',
        icon: <InboxOutlined />,
        permission: ['inventory.equipment.read'],
      },
      {
        // ⚠️ Jihozlar bilan bir modulda, lekin ALOHIDA huquq
        // (`inventory.ip.read`): IP taqsimoti "shu manzilda kim edi"
        // degan savolga javob beradi va u jihoz ro'yxatidan ko'ra
        // nozikroq — huquqiy murojaatlarda aynan shu so'raladi.
        path: '/ip-pools',
        labelKey: 'nav.ipPools',
        icon: <ApiOutlined />,
        permission: ['inventory.ip.read'],
      },
    ],
  },
  /*
    Ombor — `inventory` moduli kengaytmasi (QARORLAR.md §20.7, 6-qadam).

    ⚠️ ALOHIDA GURUH, `Tarmoq` ichida EMAS — garchi jihozlar
    (`/inventory`) o'sha yerda tursa ham. Ular BOSHQA savolga xizmat
    qiladi: `nas`/`sites`/`inventory` "abonent internetni qanday oladi"
    haqida, bu esa "molimiz qancha va qayerda". Boshqa foydalanuvchi
    (omborchi), boshqa rol, boshqa hisobot.

    ⚠️ Jihoz va mol turi BIR MODULDA, lekin ikki xil MODEL: birinchisi
    seriya raqamli fizik nusxa, ikkinchisi miqdorli tur (§20.8).
    Shuning uchun huquqlari ham alohida (`inventory.equipment.*` va
    `inventory.stock.*`).

    TARTIB MA'NOLI, alifbo bo'yicha emas — u kundalik ishning
    chastotasini takrorlaydi:
      Qoldiqlar → har kuni ochiladigan ekran, amallar ham shu yerdan
      Mollar    → ma'lumotnoma, kamdan-kam tegiladi
      Jurnal    → "nima bo'ldi" degan savol tug'ilganda
  */
  {
    key: 'stock',
    labelKey: 'nav.group.stock',
    icon: <ShoppingCartOutlined />,
    items: [
      {
        path: '/stock/balances',
        labelKey: 'nav.stockBalances',
        icon: <ShoppingCartOutlined />,
        permission: ['inventory.stock.read'],
      },
      {
        path: '/stock/items',
        labelKey: 'nav.stockItems',
        icon: <TagsOutlined />,
        permission: ['inventory.stock.read'],
      },
      {
        path: '/stock/movements',
        labelKey: 'nav.stockMovements',
        icon: <HistoryOutlined />,
        permission: ['inventory.stock.read'],
      },
      {
        path: '/stock/transfers',
        labelKey: 'nav.stockTransfers',
        icon: <SwapOutlined />,
        permission: ['inventory.stock.read'],
      },
      {
        path: '/stock/purchase-receiving',
        labelKey: 'nav.purchaseReceiving',
        icon: <InboxOutlined />,
        permission: ['purchase.receive'],
      },
      /*
        ⚠️ IKKI HUQUQ — guruhdagi yagona shunday band, va bu ataylab.
        Sahifada uch narsa bor va ular boshqa-boshqa huquq talab qiladi:
        ro'yxatni ko'rish (`inventory.stock.read`), qaror qabul qilish
        (`inventory.stock.adjust`) va CHEGARANI o'zgartirish
        (`settings.update` — `StockResource#updatePolicy`: omborchi o'z
        nazoratini o'chira olmasin).

        Faqat `inventory.stock.read` qo'yilsa, chegara egasi — amalda
        `ADMIN`, unda `settings.update` bor, ombor huquqlari yo'q
        (`V202608131600` seedi) — bandni UMUMAN ko'rmasdi. Menyuda
        bo'lmagan sahifani esa hech kim qidirmaydi.
      */
      {
        path: '/stock/approvals',
        labelKey: 'nav.stockApprovals',
        icon: <SafetyCertificateOutlined />,
        permission: ['inventory.stock.read', 'settings.update'],
      },
    ],
  },
  /*
    Kadrlar — `xsib-hr` (QARORLAR.md §20.5, §20.7 5-qadam) VA davomat
    (yuzni tanish terminallari, Hikvision DS-K1T343MFWX).

    ⚠️⚠️ 2026-08-13: «DAVOMAT» GURUHI SHU YERGA BIRLASHTIRILDI (egasi
    qarori, so'zma-so'z: "davomat bilan kadrlar ... bitta qilsa
    bo'ladigan menyularni bitta qilish kk").

    ⚠️ SHU O'RINDA ILGARI TESKARI QAROR TURGAN EDI: "ULAR BITTA
    GURUHGA BIRLASHTIRILMAGAN va bu ataylab". U BEKOR QILINDI. Uni
    ORQAGA QAYTARMANG — quyida eski dalil ham, nega u yetarli
    bo'lmagani ham yozilgan.

    Eski dalil (§20.6): `hr.person` — OBRO'LI MANBA,
    `attendance.employee.full_name` — KESH (qurilma ekrani uchun
    nusxa); bitta bo'limda ko'rsatish "qaysi birida ismni tuzatay?"
    degan chalkashlik tug'diradi.

    ⚠️ Dalil TO'G'RI, lekin ayrim guruh uni HAL QILMAGAN edi — aksincha,
    yashirgan. O'lchov (2026-08-13):
      · `nav.hrPersons` va `nav.attendanceEmployees` UCHALA TILDA ham
        AYNAN bir xil edi: «Xodimlar» / «Employees» / «Сотрудники».
        Ya'ni menyuda ikki bir xil nomli band, ikki qo'shni guruhda.
      · `attendance.employee.person_ref` — 3 qatordan 0 tasi
        to'ldirilgan; panel uni HECH QACHON yubormaydi; backendda
        `hr` → `attendance` sinxronizatsiyasi UMUMAN yozilmagan.
    Ya'ni bugun bu ikki reyestr uzilgan va faqat NOMI bir xil edi.

    ⚠️ SHUNING UCHUN CHALKASHLIK GURUH BILAN EMAS, YORLIQ BILAN
    ajratiladi (§23.4 glossariysiga qo'shildi):
      Xodimlar          — `hr.person`, OBRO'LI reyestr, ism SHU YERDA
      Kirish ruxsatlari — `attendance.employee`, qurilmadagi yuz
                          kutubxonasi: kim eshikdan o'ta oladi
    Ikkinchi nom sahifaning HAQIQIY ishini aytadi (tabel raqami, foto,
    amal muddati, qurilmaga sinxron) — «Xodimlar» esa aytmasdi.

    ⚠️ `nav.attendanceDevices` va `nav.attendanceReport` HAM qayta
    nomlandi va sababi shu birlashtirishning O'ZIDA: ilgari ularni
    «Davomat» guruhi ajratib turardi. Guruh yo'qolgach «Qurilmalar»
    `Tarmoq` dagi «NAS qurilmalari» bilan, «Hisobot» esa yuqori
    darajadagi «Hisobotlar» bilan bir ekranda chalkashardi (uz da
    «Hisobot»/«Hisobotlar», ru da «Отчёт»/«Отчёты» — bir harf farq).

    TARTIB MA'NOLI, alifbo bo'yicha emas — u ishning ketma-ketligini
    takrorlaydi va MANBADAN boshlanadi:
      Xodimlar          → odam reyestrga kiritiladi (obro'li yozuv)
      Lavozimlar        → uning MA'LUMOTNOMASI
      Davomat qurilmalari → terminal ulanadi
      Kirish ruxsatlari → odam qurilmaga yuboriladi
      Hodisalar         → qurilma nima ko'rganini xabar qiladi (XOM)
      Davomat hisoboti  → o'sha hodisalardan chiqarilgan XULOSA
    Oxirgi ikkitasini almashtirish noto'g'ri bo'lardi: hisobotdagi
    raqamga shubha tug'ilganda javob hodisalar jurnalida, ya'ni undan
    OLDINGI qadamda qidiriladi.

    ⚠️ IKKI BAND, IKKI ISH — `plans`/`policies` bilan bir xil ajratish:
      Xodimlar   — kundalik ish: qabul qilish, ko'chirish, bo'shatish
      Lavozimlar — MA'LUMOTNOMA: katalogni to'ldirish
    Ikkinchisi backendda ham alohida huquq ostida (`hr.jobtitle.write`),
    lekin BANDNI ko'rish uchun `hr.person.read` yetarli: katalog
    tayinlash oynasi uchun baribir kerak.

    ⚠️ HUQUQLAR BIRLASHMADI. `attendance.read` kabi bitta umumiy ruxsat
    yo'q va bo'lmasligi ham kerak: kadrlar xodimi hisobotni ko'radi,
    lekin terminal parolini tahrirlashi shart emas — va aksincha. Guruh
    faqat yorliq; `useSidebarMenu` HAR BANDNI alohida filtrlaydi,
    `router.tsx` esa uni majburlaydi. Ya'ni bu birlashtirish hech
    kimga bitta ham yangi sahifa ochmadi.

    ⚠️ NEGA `Tarmoq` ICHIDA EMAS: davomat ISP xizmatiga aloqador emas.
    `nas`/`sites`/`inventory` "abonent internetni qanday oladi" degan
    savolga xizmat qiladi, bu esa "kim binoga kirdi".

    ⚠️ KELAJAK: `person_ref` haqiqatan ulanganda «Kirish ruxsatlari»
    ning yarmi (ism, tabel) o'qish-uchun bo'lib qoladi va o'shanda u
    alohida band emas, xodim KARTOCHKASINING ichidagi bo'lim bo'lishi
    kerak. Ya'ni bugungi shakl — oraliq qadam, oxirgi emas.
  */
  {
    key: 'hr',
    labelKey: 'nav.group.hr',
    icon: <TeamOutlined />,
    items: [
      {
        path: '/hr/persons',
        labelKey: 'nav.hrPersons',
        icon: <IdcardOutlined />,
        permission: ['hr.person.read'],
      },
      {
        path: '/hr/job-titles',
        labelKey: 'nav.hrJobTitles',
        icon: <SolutionOutlined />,
        permission: ['hr.person.read'],
      },
      /*
        ⚠️ Kadrlar oqimi — AYNI `hr.person.read` huquqi ostida.

        Sabab backendda yozilgan (`TurnoverServiceImpl` javadoc'i):
        hisobot xodimlar ro'yxatidan kelib chiqadi va undan KAM
        ma'lumot beradi — faqat sanoq, ism yo'q. Alohida huquq kodi
        ochish uni ko'radigan doirani kengaytirmasdi, faqat rol
        konstruktorida yana bitta band paydo bo'lardi.
      */
      {
        path: '/hr/turnover',
        labelKey: 'nav.hrTurnover',
        icon: <SolutionOutlined />,
        permission: ['hr.person.read'],
      },
      /*
        ⚠️ ISH HAQI VA TA'TIL — 2026-08-14 da qo'shildi.

        Joyi MA'NOLI va yuqoridagi tartibning davomi: odam reyestrga
        kiritiladi (Xodimlar) → lavozimi ma'lumotnomadan olinadi
        (Lavozimlar) → unga pul hisoblanadi (Vedomostlar) → ish
        vaqtidan chiqishi yoziladi (Ta'tillar) va uning ma'lumotnomasi
        alohida turadi (Ta'til turlari). Davomat qurilmalari shundan
        KEYIN — ular boshqa savolga javob beradi («kim eshikdan o'tdi»).

        ⚠️ HUQUQLAR ALOHIDA va bu ataylab: `hr.person.read` bu uch
        bandning BIRORTASINI ham ochmaydi. Maosh — eng maxfiy ma'lumot
        va uning huquqi hech bir tizim roliga o'z-o'zidan tushmaydi
        (`V202608150700`: birortasi ham `.read` bilan tugamaydi, ya'ni
        `identity.seed_system_roles()` ularni umuman ko'rmaydi).
        Ya'ni bu bandlar `ADMIN`/`SUPERADMIN` dan tashqari HECH KIMGA
        o'z-o'zidan ko'rinmaydi — rol operator tomonidan beriladi.

        ⚠️ «Vedomostlar» va «Ta'tillar» IKKI BOSHQA huquq ostida
        (`hr.payroll.view` va `hr.leave.view`): buxgalter vedomostni
        ko'radi, kadr xodimi esa ta'tilni — va ular bir-birining
        ekranini ochishi shart emas.

        ⚠️ «Ta'til turlari» ATAYLAB `hr.leave.view` ostida, o'z yozish
        huquqi ostida emas: katalog ta'til so'rash oynasining bir
        qismi, ya'ni ko'rish huquqi bori uni baribir ko'radi
        (`nav.hrJobTitles` bilan aynan bir xil mulohaza).
      */
      /*
        ⚠️ MAOSHLAR va ISH HAQI QISMLARI — 2026-08-14 da qo'shildi.

        Joyi vedomostdan OLDIN: avval kim qancha oladi belgilanadi
        (Maoshlar), uning tarkibi ma'lumotnomadan olinadi (Ish haqi
        qismlari), keyin oy oxirida vedomost yig'iladi.

        ⚠️ IKKALASI HAM `hr.salary.view` ostida, `hr.paycomponent.write`
        ostida EMAS: katalog maosh ekranlarining bir qismi va faqat
        yozish huquqi bor odam uni ko'ra olmasa, tanlov ro'yxati
        qayerdan kelishini bilmasdi (`nav.hrLeaveTypes` bilan aynan bir
        xil mulohaza).
      */
      {
        path: '/hr/salaries',
        labelKey: 'nav.hrSalaries',
        icon: <DollarOutlined />,
        permission: ['hr.salary.view'],
      },
      {
        path: '/hr/pay-components',
        labelKey: 'nav.hrPayComponents',
        icon: <ProfileOutlined />,
        permission: ['hr.salary.view'],
      },
      {
        path: '/hr/payroll',
        labelKey: 'nav.hrPayroll',
        icon: <FileDoneOutlined />,
        permission: ['hr.payroll.view'],
      },
      {
        path: '/hr/leave',
        labelKey: 'nav.hrLeave',
        icon: <CalendarOutlined />,
        permission: ['hr.leave.view'],
      },
      {
        path: '/hr/leave-types',
        labelKey: 'nav.hrLeaveTypes',
        icon: <ProfileOutlined />,
        permission: ['hr.leave.view'],
      },
      {
        path: '/hr/rating-criteria',
        labelKey: 'nav.hrRatingCriteria',
        icon: <StarOutlined />,
        permission: ['hr.rating.view'],
      },
      {
        path: '/attendance/devices',
        labelKey: 'nav.attendanceDevices',
        icon: <ScanOutlined />,
        permission: ['attendance.device.read'],
      },
      {
        path: '/attendance/employees',
        labelKey: 'nav.attendanceEmployees',
        icon: <ScheduleOutlined />,
        permission: ['attendance.employee.read'],
      },
      {
        path: '/attendance/events',
        labelKey: 'nav.attendanceEvents',
        icon: <FieldTimeOutlined />,
        permission: ['attendance.event.read'],
      },
      {
        path: '/attendance/report',
        labelKey: 'nav.attendanceReport',
        icon: <SolutionOutlined />,
        permission: ['attendance.report.read'],
      },
    ],
  },
  /*
    Hisobotlar.

    ⚠️ JOYI O'ZGARMADI va bu ataylab: u shu yerda, operatsion
    bo'limlardan KEYIN va yordamchilardan (bildirishnoma, CRM, tizim)
    OLDIN turadi. Yuqoridagilarning hammasi ma'lumot ISHLAB CHIQARADI,
    bu esa uni O'QIYDI. Uni ro'yxat boshiga ko'chirish bir bosish
    tejamas, faqat operatorning odatini buzardi.

    ⚠️ 2026-08-13 da bu YOLG'IZ BAND qilingan edi (§28.2) va sabab
    aniq yozilgan: «ichida bittagina havola bo'lgan guruh akkordeonni
    ochib, bitta havola ko'rsatardi». O'sha sabab BUGUN QO'LLANMAYDI —
    bandlar uchta bo'ldi:
      · Hisobotlar        — `ReportsPage` (trafik, daromad, top, agent, qurilma)
      · Daromad kesimlari — `/api/reports/revenue/by/{dimension}`
      · Abonent harakati  — `/api/reports/subscriber-movement`

    ⚠️ Bu §28 ni ORQAGA QAYTARISH EMAS: o'sha qaror BIR BANDLI guruhni
    taqiqlagan edi, bandlar sonini emas. Uchtasini bitta sahifaga
    tiqish `ReportsPage` ni 1 200 qatordan ham kattalashtirardi va
    ularning har biri o'z sana oynasi, o'z kesimi va o'z eksporti bilan
    ishlaydi.

    ⚠️ Uchala band ham AYNI huquq ostida (`report.read`) — chunki
    uchala endpoint ham `@RequiresPermission(REPORT_READ)` sinf
    darajasida. Menyu huquqni O'YLAB TOPMAYDI, kontrollerdan oladi.
  */
  {
    key: 'reports',
    labelKey: 'nav.group.reports',
    icon: <BarChartOutlined />,
    items: [
      {
        path: '/reports',
        labelKey: 'nav.reports',
        icon: <BarChartOutlined />,
        permission: ['report.read'],
      },
      {
        path: '/reports/revenue-by',
        labelKey: 'nav.reportsRevenueBy',
        icon: <PieChartOutlined />,
        permission: ['report.read'],
      },
      {
        path: '/reports/subscriber-movement',
        labelKey: 'nav.reportsSubscriberMovement',
        icon: <RiseOutlined />,
        permission: ['report.read'],
      },
    ],
  },
  {
    key: 'notify',
    labelKey: 'nav.group.notify',
    icon: <BellOutlined />,
    items: [
      {
        path: '/notify/templates',
        labelKey: 'nav.notifyTemplates',
        icon: <MailOutlined />,
        permission: ['notify.template.read'],
      },
      {
        path: '/notify/subscriptions',
        labelKey: 'nav.notifySubscriptions',
        icon: <BellOutlined />,
        permission: ['notify.subscription.read'],
      },
      {
        path: '/notify/messages',
        labelKey: 'nav.notifyMessages',
        icon: <HistoryOutlined />,
        permission: ['notify.message.read'],
      },
      {
        path: '/notify/quiet-hours',
        labelKey: 'nav.notifyQuietHours',
        icon: <ClockCircleOutlined />,
        permission: ['notify.quiethours.read'],
      },
    ],
  },
  /*
    CRM — mijoz bilan ishlash: murojaat, lid, aloqa.

    ⚠️ HAR BAND O'Z HUQUQI BILAN, umumiy `crm.read` YO'Q — backendda
    ham shunday. Sotuvchi lidlarni ko'radi, lekin texnik murojaatlarga
    tegmasligi mumkin; qo'llab-quvvatlash esa aksincha. Ularni bitta
    ruxsatga birlashtirish ikkala rolga ham ortiqcha huquq berardi.
  */
  {
    key: 'crm',
    labelKey: 'nav.group.crm',
    icon: <CustomerServiceOutlined />,
    items: [
      {
        path: '/crm/tickets',
        labelKey: 'nav.crmTickets',
        icon: <CustomerServiceOutlined />,
        permission: ['crm.ticket.read'],
      },
      {
        path: '/crm/leads',
        labelKey: 'nav.crmLeads',
        icon: <SolutionOutlined />,
        permission: ['crm.lead.read'],
      },
      {
        path: '/crm/interactions',
        labelKey: 'nav.crmInteractions',
        icon: <PhoneOutlined />,
        permission: ['crm.interaction.read'],
      },
    ],
  },
  {
    key: 'system',
    labelKey: 'nav.group.system',
    icon: <SettingOutlined />,
    items: [
      {
        path: '/users',
        labelKey: 'nav.users',
        icon: <UserOutlined />,
        permission: ['user.read', 'role.read'],
      },
      {
        // Rollar foydalanuvchilardan KEYIN: avval "kim ishlaydi", keyin
        // "u nima qila oladi". Ikkalasi bitta sahifaga sig'maydi —
        // rol tuzish 112 ta huquqli forma, rol berish esa bir qatorli amal.
        path: '/roles',
        labelKey: 'nav.roles',
        icon: <SafetyCertificateOutlined />,
        permission: ['role.read'],
      },
      {
        path: '/audit',
        labelKey: 'nav.audit',
        icon: <AuditOutlined />,
        permission: ['audit.read'],
      },
      {
        // Fon vazifalari — AMALLAR JURNALIDAN KEYIN va bu joylashuv
        // ma'noli: ikkalasi ham "nima bo'ldi" degan savolga javob
        // beradi, faqat biri ODAM haqida, ikkinchisi MEXANIZM haqida.
        // Yonma-yon turgani "abonentga paket berilmadi — buni odam
        // qilmaganmi yoki job yurmaganmi?" degan savolga bir bosishda
        // javob berishga xizmat qiladi.
        //
        // ⚠️ `Tizim` guruhida, `Tarmoq` da EMAS: bu sahifa ISP xizmati
        // haqida emas, PLATFORMANING o'zi haqida. Uni tarmoq bo'limiga
        // qo'yish "qurilma ishlayaptimi" bilan "kodimiz yuryaptimi"
        // ni bir xil narsadek ko'rsatardi.
        //
        // ⚠️ `job.run.view` — `.read` EMAS (`permissions.ts` dagi izoh).
        path: '/jobs',
        labelKey: 'nav.jobs',
        icon: <SyncOutlined />,
        permission: ['job.run.view'],
      },
      {
        // Tashkilotlar reyestri — PLATFORMA darajasidagi bo'lim.
        // `settings` bilan yonma-yon, lekin BIRLASHTIRILMAGAN: sozlamalar
        // "o'z tashkilotim", bu esa "platformadagi barcha tashkilotlar".
        //
        // ⚠️ IKKI shart: `tenant.read` huquqi VA GLOBAL doira. Ikkinchisi
        // `globalScopeOnly` orqali — sababi shu interfeys ta'rifida.
        path: '/tenants',
        labelKey: 'nav.tenants',
        icon: <BankOutlined />,
        permission: ['tenant.read'],
        globalScopeOnly: true,
      },
      {
        path: '/settings',
        labelKey: 'nav.settings',
        icon: <SettingOutlined />,
        permission: ['settings.read'],
      },
      {
        path: '/cash/discount-policies',
        labelKey: 'nav.discountPolicies',
        icon: <SafetyCertificateOutlined />,
        permission: ['cash.discount.policy'],
      },
      {
        path: '/cash/payment-categories',
        labelKey: 'nav.paymentCategories',
        icon: <OrderedListOutlined />,
        permission: ['settings.update'],
      },
      {
        path: '/cash/transfer-types',
        labelKey: 'nav.transferTypes',
        icon: <SwapOutlined />,
        permission: ['settings.update'],
      },
      {
        path: '/cash/expense-categories',
        labelKey: 'nav.expenseCategories',
        icon: <TagsOutlined />,
        permission: ['finance.account.write'],
      },
      {
        // PSP sozlamalari — `payment.read` EMAS, `psp.read`. Chegaralar va
        // IP allowlist to'lovlarni to'xtatib qo'yishi mumkin, ya'ni ularni
        // ko'rish "to'lovlar ro'yxatini ko'rish" bilan bir daraja emas
        // (docs/04-ROLES.md §6 — `psp.configure` XAVFLI huquq).
        path: '/payment-providers',
        labelKey: 'nav.paymentProviders',
        icon: <ApiOutlined />,
        permission: ['psp.read'],
      },
      {
        path: '/settings/branding',
        labelKey: 'nav.branding',
        icon: <PictureOutlined />,
        permission: ['settings.read'],
      },
      {
        path: '/settings/whatsapp',
        labelKey: 'nav.whatsapp',
        icon: <WhatsAppOutlined />,
        permission: ['notify.whatsapp.manage'],
      },
    ],
  },
]

/**
 * Faqat guruhlar — akkordeon holati uchun.
 *
 * ⚠️ `NAV` dan HOSIL QILINADI, qo'lda takrorlanmaydi: ikki ro'yxat
 * bo'lsa ular asta-sekin ayrilib ketardi va yangi guruh menyuda
 * ko'rinib, akkordeonda esa ochilmay qolardi.
 */
export const NAV_GROUPS: readonly NavGroup[] = NAV.filter(isNavGroup)

/** Barcha havolalar tekis ro'yxatda — sarlavha topish uchun */
export const ALL_NAV_ITEMS: readonly NavItem[] = NAV.flatMap((entry) =>
  isNavGroup(entry) ? entry.items : [entry],
)

/**
 * Yo'lga eng mos keluvchi element — eng UZUN mos prefiks.
 *
 * `/` hamma narsaning prefiksi, shuning uchun oddiy `startsWith` bilan
 * "Dashboard" doim tanlangan bo'lib qolardi. Uzunlik bo'yicha saralash
 * `/subscribers/42` da "Abonentlar"ni to'g'ri belgilaydi.
 */
// eslint-disable-next-line react-refresh/only-export-components
export function findNavItem(pathname: string): NavItem | undefined {
  return ALL_NAV_ITEMS.filter((item) =>
    item.path === '/' ? pathname === '/' : pathname.startsWith(item.path),
  ).sort((a, b) => b.path.length - a.path.length)[0]
}

/**
 * Shu yo'l qaysi guruhga tegishli.
 *
 * Akkordeon uchun MAJBURIY: `/subscribers/42` ga to'g'ridan-to'g'ri
 * kirilganda "Abonentlar" guruhi ochiq turishi kerak, aks holda foydalanuvchi
 * qayerdaligini ko'rmaydi.
 *
 * ⚠️ YUQORI DARAJADAGI BAND uchun `undefined` qaytadi va bu TO'G'RI:
 * uning guruhi yo'q, ya'ni ochiladigan narsa ham yo'q. `useSidebarMenu`
 * bunda ochiq guruhni O'ZGARTIRMAYDI — «Boshqaruv paneli» ga bosish
 * ochiq bo'limni yopib yuborishi kerak emas.
 */
// eslint-disable-next-line react-refresh/only-export-components
export function findNavGroupKey(pathname: string): string | undefined {
  const item = findNavItem(pathname)
  if (!item) return undefined
  return NAV_GROUPS.find((group) => group.items.some((i) => i.path === item.path))?.key
}
